<div>
    @if (onboardingStep() === 1) {
        <app-configure-qr
            (confirmClose)="confirmCloseStepper.emit()"
            (onStepChange)="onStepChange()"
        ></app-configure-qr>
    }
    @if (onboardingStep() === 2) {
        <app-review-qr (onClose)="onCloseClientStepper.emit()"></app-review-qr>
    }
</div>
